import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Doctor {
  id: string
  name: string
  email: string
  hospitalId: string
  hospitalName: string
  specialty: string
  licenseNumber: string
  tel: string
  status: 'active' | 'inactive'
  permissions: string[]
  createdAt: string
  updatedAt: string
}

interface DoctorState {
  doctors: Doctor[]
  addDoctor: (doctor: Omit<Doctor, 'id' | 'createdAt' | 'updatedAt'>) => string
  getDoctor: (id: string) => Doctor | undefined
  getDoctorsByHospital: (hospitalId: string) => Doctor[]
  updateDoctor: (id: string, data: Partial<Doctor>) => void
  deleteDoctor: (id: string) => void
}

const initialDoctors: Doctor[] = [
  {
    id: 'doc-001',
    name: '吉岡 紘平',
    email: 'yoshioka@base-clinic.jp',
    hospitalId: 'hosp-001',
    hospitalName: 'Baseクリニック赤坂',
    specialty: '消化器内科',
    licenseNumber: 'MD-123456',
    tel: '03-1234-5678',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集', '予約管理'],
    createdAt: '2020-04-01',
    updatedAt: '2024-01-15',
  },
  {
    id: 'doc-009',
    name: '佐々木 美咲',
    email: 'sasaki@base-clinic.jp',
    hospitalId: 'hosp-001',
    hospitalName: 'Baseクリニック赤坂',
    specialty: '精神科',
    licenseNumber: 'MD-234567',
    tel: '03-1234-5679',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集'],
    createdAt: '2021-06-01',
    updatedAt: '2024-02-10',
  },
  {
    id: 'doc-002',
    name: '山田 太郎',
    email: 'yamada@sante-clinic.jp',
    hospitalId: 'hosp-002',
    hospitalName: 'サンテクリニック',
    specialty: '内科',
    licenseNumber: 'MD-345678',
    tel: '03-2345-6789',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集', '予約管理'],
    createdAt: '2019-06-15',
    updatedAt: '2024-02-20',
  },
  {
    id: 'doc-003',
    name: '城谷 昌彦',
    email: 'shirotani@shirotani-clinic.jp',
    hospitalId: 'hosp-003',
    hospitalName: '城谷バイオウェルネスクリニック',
    specialty: '消化器内科',
    licenseNumber: 'MD-456789',
    tel: '03-3456-7890',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集', '予約管理', 'レポート閲覧'],
    createdAt: '2018-03-10',
    updatedAt: '2024-03-05',
  },
  {
    id: 'doc-010',
    name: '木村 大輔',
    email: 'kimura@shirotani-clinic.jp',
    hospitalId: 'hosp-003',
    hospitalName: '城谷バイオウェルネスクリニック',
    specialty: '消化器内科',
    licenseNumber: 'MD-567890',
    tel: '03-3456-7891',
    status: 'active',
    permissions: ['患者閲覧', '診療記録閲覧', '診療記録編集'],
    createdAt: '2022-01-15',
    updatedAt: '2024-02-28',
  },
  {
    id: 'doc-004',
    name: '佐藤 健一',
    email: 'sato@futako-medical.jp',
    hospitalId: 'hosp-004',
    hospitalName: '二子玉川メディカルクリニック',
    specialty: '内科',
    licenseNumber: 'MD-678901',
    tel: '03-4567-8901',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集', '予約管理'],
    createdAt: '2021-01-20',
    updatedAt: '2024-01-10',
  },
  {
    id: 'doc-005',
    name: '田村 一郎',
    email: 'tamura@kansha-clinic.jp',
    hospitalId: 'hosp-005',
    hospitalName: '感謝クリニック',
    specialty: '小児科',
    licenseNumber: 'MD-789012',
    tel: '06-1234-5678',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集'],
    createdAt: '2020-08-01',
    updatedAt: '2024-02-28',
  },
  {
    id: 'doc-006',
    name: '鈴木 花子',
    email: 'suzuki@lagom-clinic.jp',
    hospitalId: 'hosp-006',
    hospitalName: 'LAGOMクリニック',
    specialty: '小児科',
    licenseNumber: 'MD-890123',
    tel: '052-234-5678',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集'],
    createdAt: '2022-04-15',
    updatedAt: '2024-03-01',
  },
  {
    id: 'doc-007',
    name: '高橋 誠',
    email: 'takahashi@yorozu-clinic.jp',
    hospitalId: 'hosp-007',
    hospitalName: 'よろずクリニック',
    specialty: '小児科',
    licenseNumber: 'MD-901234',
    tel: '092-345-6789',
    status: 'active',
    permissions: ['患者閲覧', '患者編集', '診療記録閲覧', '診療記録編集', '予約管理'],
    createdAt: '2021-09-01',
    updatedAt: '2024-02-15',
  },
  {
    id: 'doc-008',
    name: '中川 直哉',
    email: 'nakagawa@symbiosis.jp',
    hospitalId: 'hosp-008',
    hospitalName: 'シンバイオシス研究所',
    specialty: '研究',
    licenseNumber: 'MD-012345',
    tel: '03-5678-9012',
    status: 'active',
    permissions: ['患者閲覧', '診療記録閲覧', 'レポート閲覧'],
    createdAt: '2017-10-01',
    updatedAt: '2024-03-10',
  },
]

export const useDoctorStore = create<DoctorState>()(
  persist(
    (set, get) => ({
      doctors: initialDoctors,

      addDoctor: (doctorData) => {
        const id = `doc-${Date.now()}`
        const now = new Date().toISOString().split('T')[0]
        const newDoctor: Doctor = {
          ...doctorData,
          id,
          createdAt: now,
          updatedAt: now,
        }

        set((state) => ({
          doctors: [newDoctor, ...state.doctors],
        }))

        return id
      },

      getDoctor: (id: string) => {
        return get().doctors.find((d) => d.id === id)
      },

      getDoctorsByHospital: (hospitalId: string) => {
        return get().doctors.filter((d) => d.hospitalId === hospitalId)
      },

      updateDoctor: (id: string, data: Partial<Doctor>) => {
        set((state) => ({
          doctors: state.doctors.map((doctor) =>
            doctor.id === id
              ? { ...doctor, ...data, updatedAt: new Date().toISOString().split('T')[0] }
              : doctor
          ),
        }))
      },

      deleteDoctor: (id: string) => {
        set((state) => ({
          doctors: state.doctors.filter((doctor) => doctor.id !== id),
        }))
      },
    }),
    {
      name: 'fmt-japan-doctors',
    }
  )
)



